import React, { useEffect } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CardMap from '../../components/CardMap/CardMap';
import {
  allTenantDevices,
  tenantDeviceInfos,
} from '../Dashboard/DashboardSlice';
import { useTranslation } from 'react-i18next';
import { allDevicesCustomer, getDataDevice } from '../Device/DeviceSlice';
import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import { Skeleton, Spin } from 'antd';

const page = 0;
const pageSize = 1000;

const MapPage = () => {
  const { t } = useTranslation();
  const tenantDevices = useSelector(allTenantDevices);
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const typeAcc = useSelector((state) => state.profile.profile.authority);
  const dashboardStatus = useSelector((state) => state.dashboard.status);
  const deviceStatus = useSelector((state) => state.device.status);
  const dataCustomer = useSelector((state) => state.profile.profile);

  useEffect(() => {
    if (dashboardStatus === 'idle' && typeAcc && typeAcc === 'TENANT_ADMIN') {
      dispatch(tenantDeviceInfos({ token }));
    }
  }, [dashboardStatus, dispatch, typeAcc, token]);

  // CUSTOMER
  const allDevices = useSelector(allDevicesCustomer);

  useEffect(() => {
    if (typeAcc !== 'TENANT_ADMIN') {
      const customerId = dataCustomer?.customerId?.id;
      if (customerId) {
        dispatch(getDataDevice({ token, customerId, pageSize, page }));
      }
    }
  }, [dispatch, token, dataCustomer, typeAcc]);

  let locationList;
  let loadingMap;
  function noData() {
    loadingMap = <CardMap devices={[]} />;
  }

  if (dashboardStatus === 'loading' || deviceStatus === 'loading') {
    loadingMap = <Skeleton active />;
  } else if (dashboardStatus === 'success') {
    if (tenantDevices.data?.length > 0) {
      locationList = tenantDevices.data?.map((item) => ({
        name: item.name,
        longitude: item.attributes.longitude,
        latitude: item.attributes.latitude,
        image: item.attributes.avatar,
      }));
      loadingMap = <CardMap devices={locationList} />;
    } else noData();
  } else if (deviceStatus === 'idle') {
    if (allDevices?.length > 0) {
      locationList = allDevices?.map((item) => ({
        name: item.name,
        longitude: item.attributes.longitude,
        latitude: item.attributes.latitude,
        image: item.attributes.avatar,
      }));
      loadingMap = <CardMap devices={locationList} />;
    } else noData();
  }

  return (
    <section className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs floor={[{ name: t('maps') }]} />
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <Row>
                  <Col md={12}>
                    <Card>
                      <Card.Header>
                        <h5>{t('maps')}</h5>
                        <span className="d-block m-t-5">
                          {t('maps')} <code>{t('distribution')}</code>{' '}
                          {t('filter-station')}
                        </span>
                      </Card.Header>
                      <Card.Body style={{ zIndex: '0', height: '65vh' }}>
                        {' '}
                        {loadingMap}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapPage;
